import { render, staticRenderFns } from "./WidgetsEdit.vue?vue&type=template&id=1916bdb8&scoped=true&"
import script from "./WidgetsEdit.vue?vue&type=script&lang=js&"
export * from "./WidgetsEdit.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsEdit.vue?vue&type=style&index=0&id=1916bdb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916bdb8",
  null
  
)

export default component.exports